
<template>
    
    <div>
        <h1>{{ $t("catalogue.tags.title") }}</h1>
    </div>
  </template>